import { Container, IDestroyOptions, Point, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { LoginResourcePackage } from "../../resources/LoginResourcePackage";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { Event } from "event-system";
import { DropShadowFilter } from "pixi-filters";

export class ValidationFailedContainer extends Container {

    private static readonly HEADER_TEXT = "SIGN IN\nFAILED";
    private static readonly DESCRIPTION_TEXT = "SOMETHING WENT WRONG\nYOUR SIGN IN FAILED";
    private static readonly CONFIRM_TEXT = "OK";

    public readonly onConfirmed: Event;
    private readonly loginResources: LoginResourcePackage;
    private confirmButton: ButtonWithScaleAnimation;
    private buttonShadowFilter: DropShadowFilter;

    public constructor(
        loginResources: LoginResourcePackage
    ) {
        super();
        this.loginResources = loginResources;
        this.onConfirmed = new Event();
        this.build();
    }

    private build(): void {
        const frame = new Sprite(this.loginResources.assets_views_login_verificationFailed_glas_tooltip_frame_png);
        frame.anchor.x = 0.5;
        frame.width = 555;
        frame.height = 1018.21;
        this.addChild(frame);
        const headerText = new Text(ValidationFailedContainer.HEADER_TEXT, new HeaderTextStyle());
        headerText.anchor.x = 0.5;
        headerText.skew.x = -0.087;
        headerText.angle = -5;
        headerText.position.y = frame.y + 60;
        this.addChild(headerText);

        const iconTexture = this.loginResources.assets_views_login_login_failed_icons_email_icon_png;
        const frameIcon = new Sprite(iconTexture);
        frameIcon.anchor.set(0.5);
        frameIcon.position.y = headerText.y + headerText.height + 167;
        this.addChild(frameIcon);
        const shape = new Sprite(this.loginResources.assets_views_login_verificationFailed_tooltip_orange_shape_png);
        shape.anchor.x = 0.5;
        shape.width = 555;
        shape.height = 463.5;
        shape.position.y = frame.y + 620;
        this.addChild(shape);
        const descriptionText = new Text(ValidationFailedContainer.DESCRIPTION_TEXT, new DescriptionTextStyle());
        descriptionText.anchor.x = 0.5;
        descriptionText.position.y = shape.y + 113;
        this.addChild(descriptionText);

        this.confirmButton = new ButtonWithScaleAnimation(this.loginResources.assets_views_login_buttons_button_green_png);
        this.confirmButton.position.set(shape.x - this.confirmButton.width * 0.5, shape.y + shape.height - 61 - this.confirmButton.height);
        const confirmButtonText = new Text(ValidationFailedContainer.CONFIRM_TEXT, new ButtonTextStyle());
        confirmButtonText.position.set((this.confirmButton.width - confirmButtonText.width) * 0.5, (this.confirmButton.height - confirmButtonText.height) * 0.5);
        this.confirmButton.defaultView.addChild(confirmButtonText);
        this.confirmButton.onUp.add(this.confirmButtonClickHandle, this);
        this.addChild(this.confirmButton);

        this.buttonShadowFilter = new DropShadowFilter();
        this.buttonShadowFilter.offset = new Point(3, 3);
        this.buttonShadowFilter.blur = 2;
        this.buttonShadowFilter.color = 0x000000;
        this.confirmButton.filters = [this.buttonShadowFilter];
    }

    private confirmButtonClickHandle(): void {
        this.confirmButton.eventMode = "auto";
        this.onConfirmed.emit();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.confirmButton.onUp.remove(this.confirmButtonClickHandle, this);
        super.destroy(options);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 140,
            lineHeight: 112
        }));
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAngle: 7,
            dropShadowBlur: 5,
            dropShadowDistance: 3,
            dropShadowAlpha: 0.5,
            align: "center",
            fill: "#000000",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 56,
            lineHeight: 67
        }));
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAngle: 0.8,
            dropShadowBlur: 5,
            dropShadowDistance: 2,
            dropShadowAlpha: 0.5,
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 57,
            miterLimit: 0
        }));
    }
}
